import { toCamelCase, toKebabCase } from '@/util/common'

// 명령문 문자열의 생성과 파싱만 담당하는 순수 모듈. 구분자와 직렬화 형식은 저장된
// .mac 파일과의 외부 계약이므로 이 파일 밖으로 노출하지 않는다 — 실행 흐름은
// parseCommandParts·parseFormValues를 통해서만 명령문을 해석한다.
const keySeparator = '#'
const valueSeparator = '\x1F'

type CommandData = Record<string, unknown>

export function generateAnalyCommand(type: string, data: CommandData) {
  const extraCommand = `${keySeparator}VARIABLES ${JSON.stringify(data.vartypes)}`

  const basicKeys = [
    'server',
    'vars',
    'vartypes',
    'coltypes',
    'collabels',
    'categories',
    'missingvalues',
    'decimal',
  ]

  return makeTextCommand(type, data, basicKeys, extraCommand)
}

export function generateExtraCommand(type: string, data: CommandData) {
  const basicKeys = ['server', 'missingvalues']

  return makeTextCommand(type, data, basicKeys)
}

function makeTextCommand(type: string, data: CommandData, basicKeys: string[], extraCommand = '') {
  let command = extraCommand ? `${type.toUpperCase()} ${extraCommand}` : `${type.toUpperCase()}`

  const specialKeys = Object.keys(data).filter(key => !basicKeys.includes(key))

  for (const key of specialKeys) {
    command += ` ${keySeparator}${toKebabCase(key).toUpperCase()}${valueSeparator}${JSON.stringify(data[key])}`
  }

  return command
}

export function parseSyntaxCommands(content: string) {
  return content
    .split('\n')
    .map(line => line.trim())
    .filter(line => line !== '')
}

export function parseCommandParts(command: string) {
  const parts: string[] = []
  let current = ''
  let inString = false
  let escaped = false

  for (const character of command) {
    if (escaped) {
      current += character
      escaped = false
      continue
    }
    if (inString && character === '\\') {
      current += character
      escaped = true
      continue
    }
    if (character === '"') {
      current += character
      inString = !inString
      continue
    }
    if (!inString && character === keySeparator) {
      parts.push(current)
      current = ''
      continue
    }
    current += character
  }

  parts.push(current)
  return parts
}

export function parseFormValues(parts: string[], startIdx: number) {
  const formValues: CommandData = {}

  for (let i = startIdx; i < parts.length; i++) {
    const [key, value] = parts[i].split(valueSeparator)
    if (value === undefined) return null
    formValues[toCamelCase(key)] = JSON.parse(value)
  }

  return formValues
}
